import React from 'react';
import { motion } from 'framer-motion';
type Props = {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'li' | 'section';
};
export function Reveal({
  children,
  delay = 0,
  className = '',
  as = 'div'
}: Props) {
  const MotionTag = motion[as];
  return <MotionTag initial={{
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.4,
    ease: [0.23, 1, 0.32, 1],
    delay
  }} className={className} data-id="element-157" data-mp="3gh8p8rxuqm98">
      {children}
    </MotionTag>;
}